export const socialData = [
  {
    title: "Instagram",
    path: "https://www.instagram.com/dcanis_codes/",
  },
  {
    title: "GitHub",
    path: "https://www.github.com/adcanis",
  },
  {
    title: "LinkedIn",
    path: "https://www.linkedin.com/in/adcanis/",
  },
  {
    title: "Behance",
    path: "https://www.behance.net/adcanis/",
  },
];
